// extracted by mini-css-extract-plugin
export default {"font-renta":"Home_font-renta__0VBNw","home":"Home_home__9Ke73","alert":"Home_alert__Q9m-J"};